(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-oem-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lm-vehicle-browser')) {
  customElements.define('lm-vehicle-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const track = this.querySelector('.lm-oem-track');
      const controls = this.querySelector('.lm-make-controls');
      if (!track || !controls) return;
      this.ready = true;
      const previous = controls.querySelector('[data-make-prev]');
      const next = controls.querySelector('[data-make-next]');
      const all = controls.querySelector('[data-make-all]');
      controls.hidden = false;
      const update = () => {
        const expanded = all.getAttribute('aria-expanded') === 'true';
        previous.disabled = expanded || track.scrollLeft <= 2;
        next.disabled = expanded || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      all.addEventListener('click', () => {
        const expanded = all.getAttribute('aria-expanded') !== 'true';
        all.setAttribute('aria-expanded', String(expanded));
        all.textContent = expanded ? 'Show carousel' : 'Show all makes';
        track.classList.toggle('lm-oem-track--expanded', expanded);
        track.scrollLeft = 0;
        update();
      });
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
